"use strict";

define('service/file',['appkit/service', 'jquery', 'FileAPI', '../view/file.input', '../view/page.file.drop', 'uikit/modules/dimmer', 'uikit/collections/container', 'uikit/elements/text', 'uikit/modules/modal', 'uikit/elements/button', 'uikit/elements/progress', '../view/upload.manager', '../view/image.chooser'], function (Service, $, FileAPI, InputView, PageFileDrop, Dimmer, Container, TextView, Modal, ButtonView, ProgressView, UploadManager, ImageChooserView) {
  var FileService = Service.extend({
    events: {
      'app:start': 'onAppStart'
    },
    replies: {
      'download': 'downloadUrl',
      'file:enable:drop': 'enableDrop',
      'file:disable:drop': 'disableDrop',
      'image:chooser': 'imageChooser',
      'file:chooser': 'fileChooser',
      'file:upload': 'fileUpload',
      'file:manager': 'fileManager',
      'file:icon': 'getIconForFile',
      'file:convert:dataurl': 'convertFileToDataURL',
      'file:supported': 'isFileSupported'
    },
    initialize: function initialize() {
      this.dropEnableCount = 0;
      this.fileAdder = null;
    },
    onAppStart: function onAppStart() {
      this.dropView = new PageFileDrop({
        target: document.body
      }).on('file', function (file) {
        this.triggerMethod('file:drop', file);
      }, this);
    },
    onFileDrop: function onFileDrop(file) {
      var args = _.toArray(arguments);
      this.triggerMethod.apply(this, ['file:add'].concat(args));
    },
    onFileAdd: function onFileAdd(file) {
      var evObject = this.channel;
      if (this.hasFileAdder()) {
        evObject = this.fileAdder;
        if (this.fileAdder.processFile) {
          this.fileAdder.processFile(file);
        }
      }
      if (this.isImageFile(file)) {
        evObject.trigger('file:add:image', file);
      }
      if (this.isPDFFile(file)) {
        evObject.trigger('file:add:pdf', file);
      }
      if (this.isCommonFile(file)) {
        evObject.trigger('file:add:common', file);
      }
      evObject.trigger('file:add', file);
    },
    convertFileToDataURL: function convertFileToDataURL(file, fn) {
      FileAPI.readAsDataURL(file, function (evt) {
        if (evt.type == 'load') {
          var dataURL = evt.result;
          fn(null, evt.result, evt);
        } else if (evt.type == 'progress') {
          var pr = evt.loaded / evt.total * 100;
        } else {
          fn(evt);
        }
      });
    },
    setFileAdder: function setFileAdder(fileAdder) {
      this.fileAdder = fileAdder;
      return this;
    },
    clearFileAdder: function clearFileAdder() {
      this.fileAdder = null;
      return this;
    },
    hasFileAdder: function hasFileAdder() {
      return !!this.fileAdder;
    },
    isFileSupported: function isFileSupported() {
      return window.File && window.FileReader && window.FileList && window.Blob;
    },
    isImageFile: function isImageFile(file) {
      var type = this.getFileType(file);
      return type.indexOf('image') > -1;
    },
    isPDFFile: function isPDFFile(file) {
      var type = this.getFileType(file);
      return type.indexOf('pdf') > -1;
    },
    isCommonFile: function isCommonFile(file) {
      var type = this.getFileType(file),
        name = String(file.name);
      if (type.indexOf('image') > -1 || type.indexOf('pdf') > -1 || type.indexOf('spreadsheet') > -1 || type.indexOf('csv') > -1 || type.indexOf('powerpoint') > -1 || type.indexOf('wordprocessing') > -1 || name.match(/\.txt$/)) {
        return true;
      }
      return false;
    },
    getFileType: function getFileType(file) {
      return String(file.type).toLowerCase();
    },
    getIconForFile: function getIconForFile(file) {
      var icon = 'file outline',
        type;
      if (!file) {
        return icon;
      }
      type = String(file.type).toLowerCase();
      if (type.match(/image/)) {
        icon = 'file image outline';
      } else if (type.match(/javascript/)) {
        icon = 'file code outline';
      } else if (type.match(/zip/)) {
        icon = 'file archive outline';
      } else if (type.match(/audio/)) {
        icon = 'file audio outline';
      } else if (type.match(/pdf/)) {
        icon = 'file pdf outline';
      } else if (type.match(/spreadsheet/) || type.match(/csv/)) {
        icon = 'file excel outline';
      } else if (type.match(/powerpoint/)) {
        icon = 'file powerpoint outline';
      } else if (type.match(/wordprocessing/)) {
        icon = 'file word outline';
      } else if (type.match(/text/)) {
        icon = 'file text outline';
      } else if (type.match(/video/)) {
        icon = 'file video outline';
      }
      return icon;
    },
    enableDrop: function enableDrop() {
      this.dropEnableCount++;
      this.dropView.dropEnabled = true;
    },
    disableDrop: function disableDrop() {
      this.dropEnableCount = Math.max(0, this.dropEnableCount - 1);
      if (this.dropEnableCount == 0) {
        this.dropView.dropEnabled = false;
        hoverHandler(false);
      }
    },
    buildFileChooser: function buildFileChooser(options) {
      var inputView = new InputView(options);
      inputView.on('input:change', _.debounce(function () {
        inputView.destroy();
      }));
      inputView.render().$el.appendTo('body');
      inputView.triggerMethod('show');
      if (document.createEvent) {
        var evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, false);
        inputView.el.dispatchEvent(evt);
      }
      return inputView;
    },
    fileChooser: function fileChooser(options) {
      return this.buildFileChooser(options);
    },
    buildFileUpload: function buildFileUpload(options) {
      options = _.extend({}, options);
      var progressModel = new Backbone.Model(),
        content = new ProgressView({
          model: progressModel,
          showPercent: true,
          active: true,
          bindings: {
            percent: 'percent'
          }
        }),
        modal = new Modal({
          content: content,
          basic: true,
          closable: false,
          role: 'alert'
        }),
        uploadCollection = options.collection;
      content.text = 'Uploading Files';
      content.$el.css('padding-top', '2em');
      modal.on('render', function () {
        var semanticModal = modal.$el.data('moduleModal');
        semanticModal.save.focus = function () {
          var modalMsgDOM = modal.$el.find('.label').get(0);
          modalMsgDOM && modalMsgDOM.focus();
          $focusedElement = $(document.activeElement);
        };
      });
      modal.listenTo(uploadCollection, 'change:progress', function (model) {
        content.$el.find('.label').focus();
        progressModel.set('percent', uploadCollection.totalPercent());
      }).listenTo(uploadCollection, 'upload:complete', function () {
        var labelDOM = content.$el.find('.label').get(0);
        labelDOM.addEventListener('blur', function () {
          this.focus();
        });
        content.state = 'success';
        content.text = 'Upload Successful';
        labelDOM.focus();
        setTimeout(function () {
          content.active = false;
          modal.hide();
        }, 3000);
      }).listenTo(uploadCollection, 'error', function (model, xhr, err) {
        content.state = 'error';
        content.text = err.message || 'Upload Failed';
        content.active = false;
        content.showPercent = false;
        modal.closable = true;
      });
      modal.show();
      return modal;
    },
    fileUpload: function fileUpload(collection, options) {
      var target = collection.upload(options);
      this.buildFileUpload(_.extend({
        collection: collection
      }, options));
      return target;
    },
    buildFileManager: function buildFileManager(options) {
      var content = new UploadManager(options),
        events = _.extend({}, Backbone.Events),
        overlay = this.channel.request('show:overlay', content);
      overlay.active = true;
      overlay.size = 'mini';
      overlay.buttonType = 'apply';
      overlay.cancelable = true;
      return content;
    },
    fileManager: function fileManager(options) {
      var fileAdder = this.buildFileManager(options);
      this.setFileAdder(fileAdder);
      this.enableDrop();
      fileAdder.on('apply', function () {
        fileAdder.collection.each(function (model) {
          fileAdder.trigger('file', model.get('file'));
        });
      }).on('destroy', function () {
        this.disableDrop();
        this.clearFileAdder();
      }, this);
      return fileAdder;
    },
    buildImageChooser: function buildImageChooser(options) {
      options = _.extend({}, options);
      var content = new ImageChooserView(),
        modal = new Modal({
          content: content
        });
      modal.header.text = 'Add Image';
      modal.actions.addDeny(new ButtonView({
        text: 'Cancel',
        basic: true
      }));
      modal.actions.addApprove(new ButtonView({
        text: 'Confirm',
        color: 'primary',
        disabled: true
      }));
      modal.on('modal:hidden', function () {
        modal.destroy();
      }).on('approve', function () {
        if (content.selectedItem) {
          if (content.selectedItem instanceof Backbone.Model) {
            modal.triggerMethod('image:link', content.selectedItem.get('link'));
          } else {
            modal.triggerMethod('image:file', content.selectedItem);
          }
        }
      });
      modal.visible = true;
      return modal;
    },
    imageChooser: function imageChooser(options) {
      return this.buildImageChooser(options);
    },
    downloadUrl: function downloadUrl(options) {
      var externalWindow = options.externalWindow,
        windoc = externalWindow ? externalWindow.document : window.document,
        form = windoc.createElement("form"),
        data = _.extend({
          _csrf: window._csrf_token
        }, options.formData),
        url = options.url;
      if (externalWindow) {
        url = window.location.protocol + "//" + window.location.host + options.url;
      }
      form.setAttribute("accept-charset", 'UTF-8');
      form.setAttribute("action", url);
      form.setAttribute("method", options.method || "POST");
      form.setAttribute("target", externalWindow ? "_self" : "_blank");
      for (key in data) {
        var element = windoc.createElement("input");
        element.setAttribute("type", "hidden");
        element.setAttribute("name", key);
        element.setAttribute("value", data[key]);
        form.appendChild(element);
      }
      var submitEl = windoc.createElement('input');
      submitEl.setAttribute('type', 'submit');
      submitEl.setAttribute('value', 'Submit');
      form.appendChild(submitEl);
      windoc.body.appendChild(form);
      $(form).trigger('submit');
      windoc.body.removeChild(form);
    }
  });
  return FileService;
});

